// import {useEffect, useReducer, useState} from 'react';
// import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

// export default function useDialog() {
//     const location = useLocation();
//     const hash = location?.hash?.substring(1); // Remove o primeiro #
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();

//     const parseHash = hashString => {
//         if (!hashString) return {};
//         const dialogs = hashString.split('&'); // Separa os dialogs por &
//         const dialogData = {};
//         dialogs.forEach(dialog => {
//             const [dialogName, dialogId] = dialog.split('|'); // Separa nome e id por |
//             dialogData[dialogName] = dialogId || null;
//         });
//         return dialogData;
//     };

//     const dialogs = parseHash(hash);

//     const handleClose = dialogName => {
//         const updatedDialogs = {...dialogs};
//         delete updatedDialogs[dialogName];
//         const newHash = Object.entries(updatedDialogs)
//             .map(([name, id]) => `${name}${id ? `|${id}` : ''}`)
//             .join('&');

//         let params = '';
//         if (searchParams.size > 0) {
//             params = `?${searchParams.toString()}`;
//         }
//         navigate(`${location.pathname}${params}${newHash ? `#${newHash}` : ''}`, {replace: true});
//     };

//     const handleOpen = (dialogName, id = null) => {
//         const updatedDialogs = {...dialogs, [dialogName]: id};
//         const newHash = Object.entries(updatedDialogs)
//             .map(([name, id]) => `${name}${id ? `|${id}` : ''}`)
//             .join('&');

//         let params = '';
//         if (searchParams.size > 0) {
//             params = `?${searchParams.toString()}`;
//         }
//         navigate(`${location.pathname}${params}#${newHash}`);
//     };

//     return {
//         dialogs,
//         handleClose,
//         handleOpen,
//     };
// }

import {useEffect, useReducer, useState} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

export default function useDialog(dialog) {
    const location = useLocation();
    const hash = location?.hash?.split('|');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleClose = () => {
        // Mantém os query params do filtro; só remove o hash do dialog.
        const params = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
        navigate(`${location.pathname}${params}`, { replace: true });
    };

    const handleOpen = (id = null) => {
        const params = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
        const hashName = String(dialog || '').replace(/^#/, '');
        const nextHash = id && typeof id !== 'object' ? `${hashName}|${id}` : hashName;
        navigate(`${location.pathname}${params}#${nextHash}`);
    };

    return {
        id: hash[1] || null,
        open: dialog === hash[0],
        name: hash[0],
        handleClose,
        handleOpen,
    };
}

// import { useEffect, useReducer, useState } from 'react';
// import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

// const TOGGLE_DIALOG = 'TOGGLE_DIALOG';
// const OPEN_DIALOG = 'OPEN_DIALOG';
// const CLOSE_DIALOG = 'CLOSE_DIALOG';

// const dialogReducer = (state, action) => {
//     switch (action.type) {
//         case TOGGLE_DIALOG:
//             return { isOpen: !state.isOpen };
//         case OPEN_DIALOG:
//             return { isOpen: true };
//         case CLOSE_DIALOG:
//             return { isOpen: false };
//         default:
//             return state;
//     }
// };

// export const useFilter = key => {
//     // Carregar o estado inicial do sessionStorage
//     const getInitialState = () => {
//         const storedState = sessionStorage.getItem(key);
//         return storedState ? JSON.parse(storedState) : { isOpen: false };
//     };

//     const [isFilter, setSearch] = useSearchParams();

//     const [state, dispatch] = useReducer(dialogReducer, getInitialState());

//     // Sincronizar o estado com o sessionStorage sempre que o estado mudar
//     useEffect(() => {
//         sessionStorage.setItem(key, JSON.stringify(state));
//     }, [state, key]);

//     // Funções para abrir, fechar e alternar o diálogo
//     const openDialog = () => dispatch({ type: OPEN_DIALOG });
//     const closeDialog = () => dispatch({ type: CLOSE_DIALOG });
//     const toggleDialog = () => dispatch({ type: TOGGLE_DIALOG });

//     const cleanFilter = () => {
//         setSearch();
//     };

//     return {
//         isOpen: state.isOpen,
//         isFilter: !!isFilter.size,
//         openDialog,
//         closeDialog,
//         toggleDialog,
//         cleanFilter,
//     };
// };

// export default function useDialog(dialog) {
//     const location = useLocation();
//     const hash = location?.hash?.split('|');
//     const navigate = useNavigate();

//     const handleClose = () => {
//         navigate(-1, { replace: true });
//     };

//     const handleOpen = (open)=>{
//         navigate(open, { replace: true });
//     }
//     return { id: hash[1] || null, open: dialog === hash[0],  name: hash[0], handleClose, handleOpen};
// }
